module.exports = __webpack_public_path__ + "static/chromedevtools1-53543807c997edb12b128c7c6a507bce.png";